import React from 'react';

const Footer = () => {
  return (
    <footer className="aboutus-footer app-global-footer">
      <p>
        BookMySeat AI · <span style={{ color: '#ff4d4d' }}>RB</span> Edition · A Premium MERN Stack Clone of BookMyShow
      </p>
    </footer>
  );
};

export default Footer;
